import { FieldModel } from '@cibo/core'
import { Stack, Typography } from '@mui/material'
import { GridRenderCellParams, GridSortModel } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import { flatten } from 'ramda'

interface ColumnProps {
  t: TFunction
}

/**
 *  When using the fieldLocationColumn, using `mutateSortModelForLocation` in the
 *  @mui/x-data-grid-pro `onSortModelChange` for example as in `PaginatedFieldsTable`
 */
export const fieldLocationColumn = ({ t }: ColumnProps) => ({
  field: 'location',
  headerName: t('location', { ns: '@cibo/landmanager/FieldColumns' }),
  sortable: true,

  renderCell: (params: GridRenderCellParams<string, FieldModel>) => (
    <Stack>
      <Typography variant="body2">{params.row.county}</Typography>
      <Typography variant="caption">{params.row.state}</Typography>
    </Stack>
  ),
})

/**
 *  Use `mutateSortModelForLocation` when using the fieldLocationColumn
 *  for example as in `PaginatedFieldsTable`
 */
export const mutateSortModelForLocation = (sortModel: GridSortModel) => {
  const mutatedSort = sortModel.map(sortItem =>
    sortItem.field === 'location'
      ? [
          { field: 'state', sort: sortItem.sort },
          { field: 'county', sort: sortItem.sort },
        ]
      : sortItem
  )
  return flatten(mutatedSort)
}
